require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-teri-pfeffer.json") })
        }
      }, "path---blog-author-teri-pfeffer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-teri-pfeffer!./.cache/json/blog-author-teri-pfeffer.json
// module id = 712
// module chunks = 231608221292675